import { render, staticRenderFns } from "./documentsList.vue?vue&type=template&id=c6fc5356&scoped=true&"
import script from "./documentsList.vue?vue&type=script&lang=js&"
export * from "./documentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fc5356",
  null
  
)

export default component.exports